import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pictos/divers/picto_catalogue_mobile.svg")